import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

const ProgramacaoDiariasV2 = ({ history }) => {
  useEffect(() => {
    history.replace('/v2/programacao-diaria-dia');
  }, [history]);

  return null;
};

ProgramacaoDiariasV2.propTypes = {
  history: PropTypes.object.isRequired,
};

export default withRouter(ProgramacaoDiariasV2);
